// @ts-nocheck
import '@myome/ui/styles.css';
import './App.scss';

import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone.js';
import utc from 'dayjs/plugin/utc.js';
import ReactGA from 'react-ga4';
import { library } from '@fortawesome/fontawesome-svg-core';
// TODO: for for sc-26713 evaluate if importing all of these icons at app.tsx is better than at component level
import {
  faCircleCheck,
  faCreditCard,
  faEnvelope,
  faFileLines,
  faHospital,
  faUser,
} from '@fortawesome/free-regular-svg-icons';
import { faArrowRight, faBars, faCheck, faLaptopMedical, faPencil } from '@fortawesome/free-solid-svg-icons';
import {
  faBoxCheck,
  faDna,
  faFileChartColumn,
  faFiles,
  faHospitalUser,
  faHourglassClock,
  faListCheck,
  faMagnifyingGlassChart,
  faMemoCircleCheck,
  faReceipt,
  faUserDoctorMessage,
  faVialCircleCheck,
} from '@fortawesome/pro-duotone-svg-icons';
import { faFilePlusMinus } from '@fortawesome/pro-light-svg-icons';
import {
  faCalendarCircleUser,
  faCopy,
  faFilesMedical,
  faMessageLines,
  faUserCheck,
  faUserDoctor,
} from '@fortawesome/pro-regular-svg-icons';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import { ImpersonationBanner } from '@components/ImpersonationBanner/ImpersonationBanner';
import { envInfo } from '@constants/constants';
import { AxiosInterceptor } from '@hooks/useAxios';
import { KeycloakProvider } from '@hooks/useKeycloak';
import { ToastProvider } from '@hooks/useToast';

import RouterProvider from './router/routesProvider';
import Store from './store/store';

dayjs.extend(utc);
dayjs.extend(timezone);

library.add(
  faUser,
  faHospital,
  faVialCircleCheck,
  faReceipt,
  faHospitalUser,
  faPencil,
  faCheck,
  faListCheck,
  faUserDoctor,
  faLaptopMedical,
  faEnvelope,
  faBars,
  faCircleCheck,
  faCreditCard,
  faFileLines,
  faBoxCheck,
  faMemoCircleCheck,
  faHourglassClock,
  faMagnifyingGlassChart,
  faUserDoctorMessage,
  faFileChartColumn,
  faFilePlusMinus,
  faDna,
  faMessageLines,
  faFiles,
  faUserCheck,
  faCalendarCircleUser,
  faFilesMedical,
  faCopy,
  faArrowRight,
);

ReactGA.initialize(envInfo.ga_id);
const stripe = loadStripe(envInfo.stripe_api_key).catch(error => {
  console.warn(error);
  return null;
});

function App() {
  return (
    <div className='App'>
      <Elements stripe={stripe}>
        <Store>
          <ToastProvider>
            <KeycloakProvider>
              <ImpersonationBanner />
              <AxiosInterceptor>
                <RouterProvider />
              </AxiosInterceptor>
            </KeycloakProvider>
          </ToastProvider>
        </Store>
      </Elements>
    </div>
  );
}

export default App;
